import accounting from 'accounting';

function convertNumberFloatToBr(number: string | number, decimal = 2): string {
  return accounting.formatMoney(number, '', decimal, '.', ',');
}

export default convertNumberFloatToBr;
